export default {
    ALL_ATTRIBUTE_VARIANTS_EMPTY: ({ commit }) => commit('totally_empty')
}